export default __webpack_public_path__ + "static/biontech-bfdf1d4f78369f9ea0990d53d3e1027c.png";